import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const BotIcon = (p: IconProps) => <Icon {...p}><rect x="3" y="11" width="18" height="10" rx="2" /><path d="M12 7V3M8 7l4-4 4 4" /><circle cx="12" cy="15" r="2" /><path d="M8 15h-2M18 15h-2" /></Icon>
